import * as CheckboxPrimitive from "@radix-ui/react-checkbox"; // Import Radix Checkbox
import clsx from "clsx";
import { useId } from "react";
import { Icon } from "../icon/Icon";
import {
  checkboxIndicator,
  checkboxRoot,
  checkboxRootVariants,
  labelText,
  wrapper
} from "./Checkbox.css";

/**
 * Props for the Checkbox component.
 */
export interface CheckboxProps {
  /**
   * Controls the checked state of the checkbox (for controlled components).
   * Accepts `true`, `false` .
   */
  checked: boolean;
  /**
   *
   * The label displayed next to the checkbox.
   */

  label?: string;
  /**
   * Optional additional class name(s) for the wrapper element.
   */
  className?: string;

  /**
   * Whether the checkbox is disabled.
   */
  disabled?: boolean;
  /**
   * Callback function called when the checkbox state changes.
   */
  onChange?: (checked: boolean) => void;
  /**
   * The variant of the checkbox, which affects its styling.
   */
  variant?: "ghost" | "primary";
  /**
   * If true, the checkbox will be displayed in an indeterminate state.
   */
  indeterminate?: boolean;
}

export function Checkbox({
  label,
  checked,
  className,
  disabled,
  onChange,
  variant = "primary",
  indeterminate
}: CheckboxProps) {
  const checkboxId = useId();
  return (
    <div className={clsx(wrapper, className)} data-disabled={disabled}>
      <CheckboxPrimitive.Root
        className={clsx(checkboxRootVariants[variant], checkboxRoot)}
        checked={checked}
        disabled={disabled}
        onCheckedChange={onChange}
        id={checkboxId}
      >
        <CheckboxPrimitive.Indicator className={checkboxIndicator}>
          <Icon name={indeterminate ? "indeterminate-check" : "check"} />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      <label className={labelText} htmlFor={checkboxId}>
        {label}
      </label>
    </div>
  );
}
